import React from "react";
import SimpleNavItem  from "./SimpleNavItem";
import AdvanceNavItem from "./AdvanceNavItem";

const SideBarTabs = ({ sectionId, sectionTitle, tabs }) => {
  return (
    tabs?.length > 0 && <div>
      { sectionTitle && <span className="d-block break-word font-12 text-muted font-700 px-3 pl-4">
        { sectionTitle }
      </span> }

      {
        tabs.map((tab, index) => (
          tab.subTabs ? (
            <AdvanceNavItem key={ index } tabId={ `${sectionId}-${index}` } { ...tab } />
          ) : (
            <SimpleNavItem key={ index } { ...tab } />
          )
        ))
      }
    </div>
  )
}

export default SideBarTabs;